import { store as auth } from '@/modules/auth'
import { store as settings } from '@/pages/settings'
import { store as settingEvent } from '@/pages/settings/event'
import { store as settingRSVP } from '@/pages/settings/rsvp'
import { store as financialControl } from '@/pages/settings/financial-control'
import { store as emailStatusTemplate } from '@/pages/settings/rsvp/status'
import { store as attachmentType } from '@/pages/settings/rsvp/attachmentType'
import { store as statusPends } from '@/pages/settings/rsvp/statusPends'
import { store as reports } from '@/pages/settings/reports'
import { store as filters } from '@/pages/settings/filters'
import { store as users } from '@/pages/admin/users'
import { store as schedules } from '@/pages/settings/schedules'
import { store as speakers } from '@/pages/settings/speakers'
import { store as sponsors } from '@/pages/settings/sponsors'
import { store as faqs } from '@/pages/settings/faqs'
import { store as emailSuppressions } from '@/pages/settings/email-suppressions'
import { store as testimonials } from '@/pages/settings/testimonials'
import { store as photos } from '@/pages/settings/photos'
import { store as videos } from '@/pages/settings/videos'
import { store as customization } from '@/pages/settings/customization'
import { store as emailTemplate } from '@/pages/settings/Email'
import { store as formBuilder } from '@/pages/form-builder'
import { store as thankYouPages } from '@/pages/form-builder/thank-you-pages/store'
import { store as participantCardBuilder } from '@/pages/participant-card-builder'
import { store as participant } from '@/pages/participants'
import { store as ecampaign } from '@/pages/email/campaign'
import { store as campaign } from '@/pages/wa/campaign'
import { store as messenger } from '@/pages/wa/messenger'
import { store as template } from '@/pages/wa/templates'
import { store as statusTemplate } from '@/pages/settings/wa/status'
import { store as taskTag } from '@/pages/settings/tasks/tags'
import { store as taskChangeStatus } from '@/pages/settings/tasks/change-status'
import { store as taskFlightBlock } from '@/pages/settings/tasks/flight-block'
import { store as flightBlocks } from '@/pages/settings/flight-blocks'
import { store as wa } from '@/pages/settings/wa'
import { store as inep } from '@/pages/ineps'
import { store as registrationControl } from '@/pages/registration-controls'
import { store as guest } from '@/pages/guests'
import { store as checkIn, CHECK_IN_MODULE } from '@/modules/check-in'
import { store as storage, STORAGE_MODULE } from '@/modules/storage'
import { store as tag } from '@/pages/tags'
import { store as group } from '@/pages/groups'
import { store as seating } from '@/pages/seating'
import { store as form } from '@/pages/forms'
import { store as ticket } from '@/pages/tickets'
import { store as cupon } from '@/pages/cupons'
import { store as hotel } from '@/pages/roomlist/hotel'
import { store as hotelCategory } from '@/pages/roomlist/hotel/categories'
import { store as hotelAccommodation } from '@/pages/roomlist/hotel/accommodation'
import { store as hotelAllocation } from '@/pages/roomlist/hotel/allocation/index.js'
import { store as room } from '@/pages/roomlist/rooms'
import { store as settingcheck } from '@/pages/settingscheckin'
import { store as checkinDashboard } from '@/pages/checkin-dashboard'
import { store as followUpRules } from '@/pages/settings/follow-up-rules'
import { store as journeyBuilder } from '@/pages/journey-builder'
import { store as cartaPax } from '@/pages/carta-pax'
import { store as dataIntegrations } from '@/pages/settings/data-integrations'
import { store as app } from '@/pages/app'

export default {
  auth,
  settings,
  settingEvent,
  settingRSVP,
  financialControl,
  emailStatusTemplate,
  attachmentType,
  statusPends,
  reports,
  filters,
  users,
  schedules,
  speakers,
  sponsors,
  faqs,
  emailSuppressions,
  testimonials,
  photos,
  videos,
  customization,
  emailTemplate,
  formBuilder,
  thankYouPages,
  participantCardBuilder,
  participant,
  guest,
  ecampaign,
  campaign,
  messenger,
  template,
  statusTemplate,
  taskTag,
  taskChangeStatus,
  taskFlightBlock,
  flightBlocks,
  wa,
  inep,
  registrationControl,
  [CHECK_IN_MODULE]: checkIn,
  [STORAGE_MODULE]: storage,
  tag,
  group,
  seating,
  form,
  ticket,
  cupon,
  hotel,
  hotelCategory,
  hotelAccommodation,
  hotelAllocation,
  room,
  settingcheck,
  checkinDashboard,
  followUpRules,
  journeyBuilder,
  cartaPax,
  dataIntegrations,
  app
}
